<template>
  <table>
    <template v-if="data.active || rootNode">
      <tr>
        <td :colspan="findColspan(data)">
          <orgchart-body :data="data"
                         :rootNode="rootNode"
                         :siblingNodeCounted="siblingNodeCounted"
                         :siblingNodes="siblingNodes"
                         :setActiveAssistNode="setActiveAssistNode"
                         :labels="labels"
                         :receivedOrgBodyDetail="receivedOrgBodyDetail" />
        </td>
      </tr>
      <orgchart-secretary :data="data"
                          :rootNode="rootNode"
                          :filterActive="filterActive"
                          :siblingNodes="siblingNodes"
                          :receivedOrgBodyDetail="receivedOrgBodyDetail" />
      <template v-if="typeof data.children !== 'undefined'">
        <template v-if="data.children.length > 0">
          <tr class="lines" v-if="filterActive(data.children).length > 0">
            <td :colspan="findColspan(data)">
              <div class="downLine"></div>
            </td>
          </tr>
          <tr class="lines">
            <template v-if="filterActive(data.children).length === 1">
              <td :colspan="findColspan(data)">
                <div class="downLine"></div>
              </td>
            </template>
            <template v-else-if="filterActive(data.children).length > 1">
              <td class="rightLine">&nbsp;</td>
              <template v-for="i in data.children.length - 1">
                <td class="leftLine topLine">&nbsp;</td>
                <td class="rightLine topLine">&nbsp;</td>
              </template>
              <td class="leftLine">&nbsp;</td>
            </template>
          </tr>
          <tr class="nodes">
            <td colspan="2" v-for="dataChild of data.children">
              <orgchart-node :data="dataChild"
                             :rootNode="false"
                             :receivedOrgBodyDetail="receivedOrgBodyDetail"
                             :siblingNodeCounted="data.children.length"
                             :siblingNodes="data.children" />
            </td>
          </tr>
        </template>
      </template>
    </template>
  </table>
</template>

<script>
import orgchartBody from 'components/orgchart/orgchartBody'
import orgchartSecretary from 'components/orgchart/orgchartSecretary'

export default {
  name: 'orgchart-node',
  props: {
    data: {
      type: Object,
      required: true
    },
    labels: {
      type: Object
    },
    rootNode: {
      type: Boolean,
      default: false
    },
    siblingNodeCounted: {
      type: Number,
      default: 0
    },
    siblingNodes: {
      type: Array,
      default () {
        return []
      }
    },
    receivedOrgBodyDetail: {
      type: Function
    }
  },
  beforeMount () {
    this.$set(this.data, 'active', true)
    this.$set(this.data, 'targetSide', false)
    this.$set(this.data, 'targetBottom', false)
    this.$set(this.data, 'assistActive', true)
  },
  watch: {
    data () {
      this.$set(this.data, 'active', true)
      this.$set(this.data, 'targetSide', false)
      this.$set(this.data, 'targetBottom', false)
      this.$set(this.data, 'assistActive', true)
    }
  },
  methods: {
    findColspan (data) {
      return '100'
    },
    filterActive (dataChildren) {
      return dataChildren.filter(function (dataChild) {
        if (typeof dataChild.active === 'undefined') {
          return true
        }
        return dataChild.active === true
      })
    },
    setActiveAssistNode (flgBool) {
      this.$set(this.data, 'assistActive', flgBool)
    }
  },
  components: {
    orgchartBody,
    orgchartSecretary
  }
}
</script>


// WEBPACK FOOTER //
// orgchartNode.vue?c202d94e